export const getOptionLabel = (option) => option?.name || '';
